import { makeStyles } from '@gogame/ui/styles';

import { useBoardResize, useDragInfo, useBoardSize } from '../hooks';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    height: ({ height }) => (height ? height : null),
    overflow: ({ drag }) => (drag ? 'hidden' : null),
    visibility: ({ hidden }) => (hidden ? 'hidden' : null),
    transition: 'height .3s',
  },
});

const GridBoard = ({ children }) => {
  const dragInfo = useDragInfo();
  const { boardHeight } = useBoardSize();
  const { ref } = useBoardResize();

  const classes = useStyles({
    height: boardHeight,
    drag: !!dragInfo,
    hidden: !boardHeight,
  });

  return (
    <div className={classes.root} ref={ref}>
      {children}
    </div>
  );
};

export default GridBoard;
